import React, { useEffect, useState } from 'react';
import axios from 'axios';
import useStore from '../useStore';
import { Container } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";

function LoadingIndicator() {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <div className="loading-label">Loading</div>
    </div>
  );
}

function AgencyInfo() {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [profileData, setProfileData] = useState(null);
  const setUserEmail = useStore((state) => state.setUserEmail);
  const userEmail = useStore((state) => state.userEmail);
  //const selectedAgency = useStore((state) => state.selectedAgency);
  const { selectedAgency } = useStore();
  const setSelectedAgency = useStore((state) => state.setSelectedAgency);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [agencies, setAgencies] = useState([]);
  const [isSystemUser, setIsSystemUser] = useState(false);

  useEffect(() => {
    if (activeAccount && !profileData) {
      setProfileData(activeAccount.idTokenClaims);
      const emails = activeAccount.idTokenClaims.emails;
      if (emails && emails.length > 0) {
        const email = emails[0];
        console.log('Email captured in ProfileDetails:', email);
        if (!userEmail) {
          setUserEmail(email);
        }
      } else {
        console.error('No email found in idTokenClaims');
      }
    }
  }, [activeAccount, profileData, setUserEmail, userEmail]);

   useEffect(() => {
      if (!userEmail) return;
      axios.get(`${process.env.REACT_APP_API_URL}/SystemUser?email=${userEmail}`)
        .then((response) => {
          if (response.data.systemUserId !== "00000000-0000-0000-0000-000000000000") {
            setIsSystemUser(true);
          }
        })
        .catch((error) => {
          console.error("Error checking system user:", error);
          setIsSystemUser(false);
        });
    }, [userEmail]);

  useEffect(() => {
    if (!selectedAgency && userEmail) {
      axios.get(`${process.env.REACT_APP_API_URL}/Agencies?email=${userEmail}`) // Use relative path
        .then((response) => {
          setAgencies(response.data);
          if (response.data.length === 1) {
            setSelectedAgency(response.data[0]);
          }
          setError(false);
          setLoading(false);
        })
        .catch((error) => {
          if (error.response) {
            console.log('Response error:', error.response.data);
            setError(error.response.data);
          } else if (error.request) {
            console.log('Request error:', error.request);
            setError('No response received from server');
          } else {
            console.log('General error:', error.message);
            setError(error.message);
          }
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [userEmail, selectedAgency, setSelectedAgency]);

  if (loading) return <LoadingIndicator />;
  if (error) return <div>Error: {error}</div>;

  const handleAgencyClick = (agency) => {
    setSelectedAgency(agency);
  };

  const handleBackToAgencies = () => {
    setLoading(true); // Show loading indicator
     if (isSystemUser) {
      window.location.href = "/admin-portal"; // ✅ redirect for system users
    } else {
    setSelectedAgency(null); // Reset selected agency
    }
  };
 

  return (
    <Container>
      <div>
        {selectedAgency ? (
          <> 
            <button onClick={handleBackToAgencies} style={{ marginTop: '20px', padding: '10px 20px', cursor: 'pointer', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px' }}>
              Back to Agencies
            </button>
            <h2>Agency Detail</h2>
            <p>
              <strong>Name:</strong> {selectedAgency.name}
            </p>
            <p>
              <strong>Vendor Id:</strong> {selectedAgency.vendorId}
            </p>
            <p>
              <strong>Agency Email:</strong> {selectedAgency.agencyEmail}
            </p>
            <p>
              <strong>Address Line 1:</strong> {selectedAgency.address?.addressLine1 || 'No address provided'}
            </p>
            <p>
              <strong>Address Line 2:</strong> {selectedAgency.address?.addressLine2 || ''}
            </p>
            <p>
              <strong>City:</strong> {selectedAgency.address?.city || ''}
            </p>
            <p>
              <strong>State:</strong> {selectedAgency.address?.state || ''}
            </p>
            <p>
              <strong>Zip:</strong> {selectedAgency.address?.zip || ''}
            </p>
            <p>
              <strong>Bank Details:</strong>
            </p>
            <p>
              <strong>Bank Name:</strong> {selectedAgency.bankDetails?.bankName || 'No Bank Name provided'}
            </p>
            <p style={{ display: 'none' }}>
              <strong>Bank Address:</strong> {selectedAgency.bankDetails?.bankAddress || 'No bank address provided'}
            </p>
            <p>
              <strong>Routing Number:</strong> {selectedAgency.bankDetails?.routingNumber || 'No routing number provided'}
            </p>
            <p>
              <strong>Account Number:</strong> {selectedAgency.bankDetails?.accountNumber || 'No account number provided'}
            </p>
            {/* Add the note here */}
            <div className="contact-note" style={{ marginTop: '20px', fontStyle: 'italic', color: '#555' }}>
              If you wish to change any of the address or contact information, please get in touch with us at <a href="mailto:agencyhub@unitedwayla.org">agencyhub@unitedwayla.org</a>.
            </div>
          </>
        ) : (
          <div>
            <h2>Agencies</h2>
            <ul className="agency-list">
              {agencies.map(agency => (
                <li
                  key={agency.vendorId}
                  onClick={() => handleAgencyClick(agency)}
                  className="agency-item"
                >
                  {agency.name} ({agency.vendorId})
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Container>
  );
}

export default AgencyInfo;
